/**
 * Step — Invoice Templates [TYPE B — Optional]
 *
 * Shows only the Invoice Templates tab from SettingsTemplates.
 */

import { FileText, ArrowRight } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { StepWrapper } from '../StepWrapper';
import SettingsTemplates from '@/pages/settings/settings-templates';

interface StepProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
  isLastStep: boolean;
}

export function Step6Templates({ onNext, onBack, onSkip, isLastStep }: StepProps) {
  const [showSettings, setShowSettings] = useState(false);

  return (
    <StepWrapper
      barState="default"
      barMessage="Optional — you can set up invoice templates later from Settings → Templates."
      showBack={true}
      showSkip={true}
      nextLabel={isLastStep ? 'Finish Setup →' : 'Next Step →'}
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
    >
      {!showSettings ? (
        <div className="flex flex-col items-center justify-center py-20 space-y-5 text-center px-8">
          <div className="h-16 w-16 rounded-2xl bg-primary/10 flex items-center justify-center">
            <FileText className="h-8 w-8 text-primary" />
          </div>
          <div className="space-y-2 max-w-md">
            <h3 className="text-lg font-semibold text-foreground">Invoice Templates</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Create professional invoice layouts for your clients. These are used every time
              you generate an invoice. You can configure these now or return to them later
              from <span className="font-medium">Settings → Templates</span>.
            </p>
          </div>
          <Button onClick={() => setShowSettings(true)} className="gap-2">
            Set Up Invoice Templates Now
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      ) : (
        <div className="rounded-lg border border-border overflow-hidden bg-background shadow-sm">
          <SettingsTemplates defaultTab="invoice-templates" />
        </div>
      )}
    </StepWrapper>
  );
}
